import { useRouter } from 'next/router'

const useDirectories = () => {
  const router = useRouter()
  const [asPath] = router.asPath.split('#')
  const [path] = asPath.split('?')
  const [_blank, dir, subpage, subsubpage, subsubsubpage, subsubsubsubpage, subsubsubsubsubpage] = path.split('/')
  const query = router.query

  return { dir, query, subpage, subsubpage, subsubsubpage, subsubsubsubpage, subsubsubsubsubpage }
}

export default useDirectories
